import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import Content from './Content';
import Header from './Header';

import { StyledBodyText } from './Typography';

const GlobalErrorFallback: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<Header />
			<Content>
				<StyledBodyText>{t('error.text.unknown')}</StyledBodyText>
			</Content>
		</>
	);
};

export default GlobalErrorFallback;
